import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import CrossIcon from '@atlaskit/icon/core/migration/cross';
import { messages } from '../../../../../messages';
import Action from '../action';
var DeleteAction = function DeleteAction(props) {
  return /*#__PURE__*/React.createElement(Action, _extends({
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.delete),
    icon: /*#__PURE__*/React.createElement(CrossIcon, {
      color: "currentColor",
      spacing: "spacious",
      label: "Delete"
    }),
    testId: "smart-action-delete-action",
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, messages.delete)
  }, props));
};
export default DeleteAction;